/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type ImageAiType = typeof ImageAiType[keyof typeof ImageAiType];


export const ImageAiType = {
  UNKNOWN: 'UNKNOWN',
  NONE: 'NONE',
  MODIFIED: 'MODIFIED',
  GENERATED: 'GENERATED',
} as const;
